import React from "react";
import styles from "../ResourcesPlanner.module.scss";
import { VISIBLE_LANES } from "../constants";
import { RowType } from "../engine/rowModel";
import AllocationBar from "./AllocationBar";

/**
 * One row of the timeline: the bars of its allocations that fall in the window of days. A collapsed row draws only
 * the lanes it has room for; the tasks in the lanes beyond them are listed from the left panel, so the row is the
 * same height whatever it holds.
 */
function TimelineRow({ row, top, firstDay, lastDay, originDay, dayWidth, entering }) {
  const bars = [];

  if (row.layout) {
    row.layout.forEachInRange(
      firstDay,
      lastDay,
      (taskId, lane) => {
        const allocation = row.byTask[taskId];
        if (allocation) bars.push(<AllocationBar key={taskId} allocation={allocation} lane={lane} originDay={originDay} dayWidth={dayWidth} />);
      },
      0,
      VISIBLE_LANES - 1
    );
  } else if (row.type === RowType.TASK && row.allocation.startDay !== null && row.allocation.startDay <= lastDay && row.allocation.endDay >= firstDay) {
    bars.push(<AllocationBar key={row.allocation.taskId} allocation={row.allocation} lane={0} originDay={originDay} dayWidth={dayWidth} />);
  }

  return (
    <div
      className={`${styles.row} ${entering ? styles.rowEnter : ""}`}
      data-row-key={row.key}
      data-row-type={row.type}
      data-resource={row.resourceId}
      data-project={row.projectId || ""}
      data-scope={row.scopeId || ""}
      data-group={row.groupId || ""}
      style={{ height: row.height, transform: `translateY(${top}px)` }}
    >
      {bars}
    </div>
  );
}

export default React.memo(TimelineRow);
